import { POST_MESSAGE } from '../actions/message';

const INITIAL_STATE = {
  message: {},
  error: null
};

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {

    case POST_MESSAGE:
    if(action.payload.status === 200) {
      return { ...state, message: action.payload.data };
    } else{
      if(action.payload.response){
        if (action.payload.response.status === 400) {
          return { ...state, message: action.payload.response };
        } if (action.payload.response.status === 401) {
          return { ...state, message: action.payload.response };
        }
      } else {
        return { ...state, error: "No internet connection"}
      }
    }

    break;

  	default:
    	return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducerMessage.js